import { getRetailPoint } from '~/src/api/content/retail-point';
import { SET_DEALERS } from '../actionTypes/dealers';

const convertContacts = (points) => {
    if (!Array.isArray(points)) {
        return points;
    }

    return points.map(point => {
        return {
            ...point,
            pid: point.point_id,
            name: point.point_name,
            type: point.company?.type,
            hours: point.work_time,
        };
    });
};

export function getDealersContact(domain) {
    return async(dispatch) => {
        const resp = await getRetailPoint({ domain });

        if (resp.isSuccess) {
            dispatch({
                type: SET_DEALERS,
                payload: convertContacts(resp.payload),
            });
        }
    };
}
